import React, { useEffect, useState, useRef } from 'react';
import { downloadFile, getFileIcon, parseHtml } from 'helpers/index';
import { useUnit } from 'hooks/units/index';
import useWindowSize from 'hooks/useWindowSize';
import styles from 'styles/Unit.module.scss';
import Complete from './Complete/Complete';
import ChangeUnit from '../ChangeUnit';
import { UNIT_TYPE } from '../../../../../constants/constants';
import ContentFiles from './ContentFiles';
import classNames from 'classnames';
import { Button, Card, Table, UncontrolledTooltip } from 'reactstrap';
import ListTableRow from 'components/Table/ListTableRow';
import { Download } from 'react-feather';
import { bytesToSize } from 'helpers/number';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';

import PdfViewer from 'hooks/pdfViewer';
import fileApi from 'api/fileApi';
import ReactPlayer from 'react-player';
import LoadingOverlay from 'react-loading-overlay';
import Loading from 'components/Layout/Loading';
import { Thumbnail } from './Complete/AssigmentComplete/TrackingResultAssignment';
import styled from '@emotion/styled';
import unitsApi from 'api/unitsApi';

const ATAG = styled.a`
  color: #646871 !important;
  :hover {
    text-decoration: underline;
  }
`;
const Content = (props) => {
  const unitSelected = useUnit();
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const [content, setContent] = useState('');
  const [pdfLink, setPdfLink] = useState(undefined);
  const [videoLink, setVideoLink] = useState(undefined);
  const [audioLink, setAudioLink] = useState(undefined);
  const [ytLink, setYtLink] = useState(undefined);
  const [canShowcomplete, setCanShowcomplete] = useState(true);
  const [isRender, SetIsRender] = useState(false);
  const [width, height] = useWindowSize();
  const [isLazyLoad, setIsLazyLoad] = useState(false);
  const docPDFLink = [
    {
      uri: pdfLink,
    },
    // { uri: require('./example-files/pdf.pdf') }, // Local File
  ];
  useEffect(() => {
    if (
      (unitSelected?.type == 'VIDEO' &&
        unitSelected?.config?.typeVideo == 'YOUTUBE') ||
      unitSelected?.type == 'SCORM' ||
      unitSelected?.type == 'DOCUMENT'
    ) {
      let localItemAdd = localStorage.getItem('refusedContent');
      if (localItemAdd) {
        localStorage.removeItem('refusedContent');
        SetIsRender(true);
      } else if (!isRender) {
        localStorage.setItem('refusedContent', true);
        SetIsRender(true);
        // location.reload();
      }
    }
  }, [unitSelected]);

  const resizer = async () => {
    if (!unitSelected) return;
    if (unitSelected?.content.includes('iframe')) {
      const contentElm = document.getElementById('content');
      const iframes = [...document.getElementsByTagName('iframe')];
      const { clientWidth } = contentElm;
      // resize iframe
      const contentFixed = unitSelected.content;
      iframes.map((iframe, index) => {
        iframe.style.width = `${clientWidth}px`;
        if (unitSelected?.type !== UNIT_TYPE.AUDIO) {
          iframe.style.height = `${(9 * clientWidth) / 16}px`;
        } else {
          iframe.parentNode.style.minHeight = `${(9 * clientWidth) / 16}px`;
          iframe.style.height = '270px';
          if (iframes?.length === 1 && index === 0) {
            if (iframe.parentNode.childNodes?.length === 1) {
              // only have iframe audio make it center
              iframe.parentNode.style.display = 'flex';
              iframe.parentNode.style.flexDirection = 'column';
              iframe.parentNode.style.justifyContent = 'center';
            } else {
              // have iframe audio anh more...
              iframe.style.marginTop = '3rem';
            }
          }
        }
      });
      if (
        unitSelected?.type == 'VIDEO' &&
        unitSelected?.config?.typeVideo == 'VIDEO'
      ) {
        const response = await fileApi.getFileById({
          id: unitSelected?.file,
        });
        setVideoLink(response?.path);
      }
      if (
        unitSelected?.type == 'VIDEO' &&
        unitSelected?.config?.typeVideo == 'YOUTUBE'
      ) {
        const Url = contentFixed.split('src=')[1].split(/[ >]/)[0];
        setYtLink(youtubeAutoplay(Url));
        setCanShowcomplete(false);
      }

      if (unitSelected?.type == 'AUDIO') {
        const response = await fileApi.getFileById({
          id: unitSelected?.file,
        });
        setAudioLink(response?.path);
        setCanShowcomplete(false);
      }
      if (unitSelected?.covertedFile) {
        const lastURL = contentFixed.split('src=')[1].split(/[ >]/)[0];
        let updatedURL =
          process.env.NEXT_PUBLIC_API_URL +
          unitSelected?.covertedFile +
          '#toolbar=0';
        setPdfLink(
          process.env.NEXT_PUBLIC_API_URL + unitSelected?.covertedFile,
        );
        let newURL = contentFixed.replace(lastURL, updatedURL);
        setContent(newURL);
      } else {
        setContent(
          unitSelected?.type == 'AUDIO'
            ? audioContent(contentFixed)
            : contentFixed,
        );
      }
    } else if (unitSelected?.file?.pathView) {
      const contentElm = document.getElementById('content');

      const { clientHeight } = document.body;
      const { clientWidth } = contentElm;

      setContent(
        `<iframe src="${unitSelected?.file?.pathView}" width="${clientWidth}" height="${clientHeight}"/>`,
      );
    } else {
      setContent(unitSelected?.content);
    }
  };

  const youtubeAutoplay = (content) => {
    let str = content.substring(1, content.length - 1);
    if (str.includes('autoplay')) {
      return str;
    } else {
      let ans =
        str +
        '?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=0&autoplay=1';
      return ans;
    }
  };
  const audioContent = (content) => {
    const URL = content.split('src=')[1].split(/[ >]/)[0];
    const updateURL = URL.substring(1, URL.length - 1);
    const newURL = '"' + updateURL + '?content=true' + '"';
    const editURL = content.replace(URL, newURL);
    return editURL;
  };
  async function downLoadFile(file) {
    try {
      setIsLazyLoad(true);
      await downloadFile(file?.path, file?.originalname);
      setIsLazyLoad(false);
    } catch (error) {}
  }

  useEffect(() => {
    resizer();
  }, [unitSelected?.content]);

  useEffect(() => {
    if (!unitSelected?._id) return;

    const getDateInfo = async () => {
      try {
        const { type, course, _id } = unitSelected;
        if (['LIVESTREAMING', 'CLASSROOM', 'TEST', 'SURVEY'].includes(type))
          return;

        const lessonData = {
          course,
          type,
          unit: _id,
          dateTime: Date.now(),
        };
        const res = await unitsApi.dateInfo(lessonData);
      } catch (error) {
        handleToastError(error);
      }
    };

    getDateInfo();
  }, [unitSelected]);

  return (
    <div
      className={classNames(
        `containerContent ${
          props.fullScreens && props.types !== 'AUDIO' ? 'full_video_mode' : ''
        }`,
        `${
          props.fullScreens && props.types !== 'AUDIO'
            ? 'vedio-fullscreen-display'
            : ''
        }`,
        styles['containerContent'],
        styles[
          `${
            props.fullScreens && props.types !== 'AUDIO'
              ? 'full_video_mode'
              : ''
          }`
        ],
        styles[
          `${
            props.fullScreens && props.types !== 'AUDIO'
              ? 'vedio-fullscreen-display'
              : ''
          }`
        ],
      )}
      id="content"
    >
      <div
        className={classNames(
          `${
            props.fullScreens && props.types === 'AUDIO'
              ? 'full-screen-audio'
              : ''
          }`,
          styles[
            `${
              props.fullScreens && props.types === 'AUDIO'
                ? 'full-screen-audio'
                : ''
            }`
          ],
        )}
      >
        {/* <ChangeUnit /> */}
        <>
          {pdfLink ? (
            <PdfViewer
              doc={docPDFLink}
              isDownload={
                props?.course?.rulesAndPath?._id
                  ? props?.course?.rulesAndPath?.download
                  : true
              }
            />
          ) : videoLink ? (
            <video
              src={videoLink}
              width="100%"
              className="video-responsive"
              controls
              height={500}
              controlslist="nodownload"
              style={{
                aspectRatio: '16/9',
              }}
            />
          ) : ytLink ? (
            <>
              {isRender && (
                <ReactPlayer
                  url={ytLink}
                  controls={true}
                  loop
                  className={`video-responsive ${styles.iframe_w_full}`}
                  muted={false}
                  playing={true}
                  width="100%"
                  height={500}
                  style={{
                    aspectRatio: '16/9',
                  }}
                />
              )}
              {/* <embed src={ytLink} width="100%" height="500px" /> */}
              <br />
              <br />
              {isRender && <Complete />}
            </>
          ) : audioLink ? (
            <div
              className={
                unitSelected?.complete?.question?.content
                  ? 'audio-file-content-question'
                  : 'audio-file-content'
              }
            >
              <audio
                src={audioLink}
                controls
                controlslist="nodownload"
                width="100%"
                height="500px"
              />{' '}
              <br />
              <br />
              <Complete />
            </div>
          ) : (
            <p className={`overflow-auto modal-body ${styles.iframe_w_full}`}>
              {parseHtml(content)}
            </p>
          )}
        </>

        {/* <ChangeUnit isRight /> */}
      </div>
      {unitSelected?.type === UNIT_TYPE.ASSIGNMENT &&
        unitSelected?.files?.length > 0 && (
          <LoadingOverlay
            active={isLazyLoad}
            spinner
            styles={{
              overlay: (base) => ({
                ...base,
                background: 'rgb(187 181 181 / 50%)',
                zIndex: 10,
                top: 7,
              }),
            }}
          >
            <Table className="table-header-custom " responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Size</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <ListTableRow col={4} length={unitSelected?.files?.length}>
                  {Array.isArray(unitSelected?.files) &&
                    unitSelected?.files?.map((item, index) => {
                      const { Icon, type, extension } = getFileIcon(
                        item?.pathView || item?.path,
                        item?.mimetype,
                      );

                      return (
                        <tr key={index}>
                          <td className="">
                            {/* <Thumbnail
                              src={item?.pathView || item?.path}
                              type={type}
                              id={item?._id}
                              extension={extension}
                            >
                              <div className="mx-0 d-flex  align-items-center">
                                <section className="d-flex align-items-center mr-05">
                                  {<Icon size={25} />}
                                </section>
                                <section className="px-0 line-clamp">
                                  <ATAG
                                    className="text-start text-truncate"
                                    href={item?.pathView || item?.path || '/'}
                                    target="_blank"
                                  >
                                    {item?.originalname}
                                  </ATAG>
                                </section>
                              </div>
                            </Thumbnail> */}
                            <div className="mx-0 d-flex  align-items-center">
                              <section className="d-flex align-items-center mr-05">
                                {<Icon size={25} />}
                              </section>
                              <section className="px-0 line-clamp">
                                {item?.originalname}
                              </section>
                            </div>
                          </td>
                          <td className="text-center">
                            {bytesToSize(item?.size)}
                          </td>
                          <td className="text-center">
                            <Button.Ripple
                              className="btn-icon px-05 py-05"
                              color="flat-dark"
                              id={`id-${item?._id}${index}`}
                              onClick={() => downLoadFile(item)}
                            >
                              <Download size={15} />
                              <UncontrolledTooltip
                                placement="top"
                                target={`id-${item?._id}${index}`}
                              >
                                Download
                              </UncontrolledTooltip>
                            </Button.Ripple>
                          </td>
                        </tr>
                      );
                    })}
                </ListTableRow>
              </tbody>
            </Table>
          </LoadingOverlay>
        )}
      {unitSelected?.type === UNIT_TYPE.FILES && <ContentFiles />}
      {canShowcomplete && <Complete />}
    </div>
  );
};

export default Content;
